module.exports = __webpack_public_path__ + "media/images/iconPaginateFirst__accent--dark-c05eb34d0f1e4d86c7d0554ee126176c.png";